import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../auth/AuthProvider";
import { DEFAULT_LEAGUE_VOCABULARY, subscribeLeagueVocabulary } from "../services/leagueVocabulary";

export default function useLeagueVocabulary(explicitOrgId) {
  const { claims } = useAuth();
  const orgId = String(explicitOrgId || claims?.orgId || "").trim();
  const [vocabulary, setVocabulary] = useState(DEFAULT_LEAGUE_VOCABULARY);

  useEffect(() => {
    if (!orgId) return undefined;
    return subscribeLeagueVocabulary(orgId, setVocabulary, () => setVocabulary(DEFAULT_LEAGUE_VOCABULARY));
  }, [orgId]);

  return useMemo(() => ({
    ...vocabulary,
    singularLower: vocabulary.singular.toLowerCase(),
    pluralLower: vocabulary.plural.toLowerCase(),
  }), [vocabulary]);
}
